<template>
  <div class="wrap">
    <!-- 微信认证组件 -->
    <wxAuth v-if="share" :share="share"></wxAuth>
    <headers :params="hraderP" />
    <van-form class="form" ref="formData" @submit="subMit">
      <van-field
        v-model="form.designerName"
        required
        clearable
        label="真实姓名"
        name="designerName"
        placeholder="请输入真实姓名"
        :show-error-message="false"
        maxlength="30"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        v-model="form.designerPhone"
        maxlength="11"
        required
        clearable
        type="number"
        label="联系方式"
        placeholder="请输入电话号码"
        name="designerPhone"
        :show-error-message="false"
        :rules="[{ validator, message: '' }]"
      />
      <van-field
        v-model="procity"
        right-icon="arrow"
        readonly
        required
        label="工作城市"
        placeholder="请选择工作城市"
        @click="showPC = true"
        name="procity"
        :show-error-message="false"
        :rules="[{ required: true, message: '' }]"
        maxlength="60"
      />
      <van-field
        v-model="form.designerAddress"
        label="联系地址"
        clearable
        placeholder="请输入联系地址"
        maxlength="30"
      />
      <van-field
        v-model="form.designerCompany"
        label="任职公司"
        clearable
        placeholder="请输入公司名称"
        maxlength="30"
      />
      <van-field
        v-model="form.designerWorkingTime"
        label="从业时间"
        placeholder="请选择从业时间"
        readonly
        required
        @click="isShowTime = true"
        :show-error-message="false"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        v-model="designerIdentityText"
        label="合作形式"
        readonly
        placeholder="请选择你的合作形式"
        @click="isIdentity = true"
        right-icon="arrow"
        required
        :show-error-message="false"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        label="   "
        class="list-two list-two-one list-two-hide-val"
        :class="{nopdb : forMatResult.length}"
        v-if="form.designerIdentity.includes('SJ')"
        v-model="form.designerFormats"
        readonly
        right-icon="arrow"
        clearable
        placeholder="请选择领域-业态"
        name="designerFormats"
        :show-error-message="false"
        :rules="[{ required: true, message: '' }]"
      >
        <div class="list-two-more-box" @click="isFormat = true" slot="extra">
          <div v-if="forMatResult && forMatResult.length" class="list-two-val-box">
              <div v-for="(item) in forMatResult" :key="item.id" class="list-two-val-item">
                {{item.text}}
              </div>
          </div>
          <div class="list-two-pla" v-else>请选择领域-业态</div>
          <div class="van-field__right-icon"><i class="van-icon van-icon-arrow"><!----></i></div>
        </div>
      </van-field>
      <van-field
        label="擅长领域"
        required
        class="list-two list-two-hide-val"
        :class="{nopdb : sysResult.length}"
        v-if="form.designerIdentity.includes('SJ')"
        v-model="form.designerSystem"
        right-icon="arrow"
        clearable
        readonly
        placeholder="请选择领域-系统"
        name="designerSystem"
        :show-error-message="false"
        :rules="[{ required: true, message: '' }]"
      >
        <div class="list-two-more-box" @click="issys = true" slot="extra">
          <div v-if="sysResult && sysResult.length" class="list-two-val-box">
            <div v-for="(item) in sysResult" :key="item.id" class="list-two-val-item">
              {{item.text}}
            </div>
          </div>
          <div class="list-two-pla" v-else>请选择领域-系统</div>
          <div class="van-field__right-icon"><i class="van-icon van-icon-arrow"></i></div>
        </div>
      </van-field>
      <van-field
        class="list-two list-two-one"
        v-if="form.designerIdentity.includes('SJ')"
        v-model="form.sfText"
        right-icon="arrow"
        readonly
        @click="isFeeScale = true"
        label="   "
        placeholder="请选择收费标准"
        name="sfText"
        :show-error-message="false"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        class="list-two"
        label="收费标准"
        required
        v-if="form.designerIdentity.includes('SJ')"
        v-model="form.feeScaleDetailed"
        clearable
        placeholder="请填写收费标准"
        maxlength="60"
           :show-error-message="false"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        class="list-two list-two-one list-two-hide-val"
        :class="{nopdb : ceResult.length}"
        v-if="form.designerIdentity.includes('SJ') && ceResult.includes('其他')"
        v-model="form.certificate"
        right-icon="arrow"
        clearable
        readonly
        label="    "
        placeholder="请选择证书"
      >
        <div class="list-two-more-box" @click="isShowCe = true" slot="extra">
          <div v-if="ceResult && ceResult.length" class="list-two-val-box">
              <div v-for="(item) in ceResult" :key="item" class="list-two-val-item">
                {{item}}
              </div>
          </div>
          <div class="list-two-pla" v-else>请选择证书</div>
          <div class="van-field__right-icon"><i class="van-icon van-icon-arrow"><!----></i></div>
        </div>
      </van-field>
      <van-field
        class="list-two-hide-val"
        v-if="form.designerIdentity.includes('SJ') && !ceResult.includes('其他')"
        v-model="form.certificate"
        :class="{nopdb : ceResult.length}"
        right-icon="arrow"
        clearable
        label="证书"
        readonly
        @click="isShowCe = true"
        placeholder="请选择证书"
      >
        <div class="list-two-more-box" @click="isShowCe = true" slot="extra">
          <div v-if="ceResult && ceResult.length" class="list-two-val-box">
              <div v-for="(item) in ceResult" :key="item" class="list-two-val-item">
                {{item}}
              </div>
          </div>
          <div class="list-two-pla" v-else>请选择证书</div>
          <div class="van-field__right-icon"><i class="van-icon van-icon-arrow"><!----></i></div>
        </div>
      </van-field>
      <van-field
        class="list-two"
        label="证书"
        v-if="ceResult.includes('其他')"
        v-model="inputCertificate"
        maxlength="100"
        clearable
        placeholder="请输入证书"
      />
       <!-- 是否可以提供发票 -->
      <van-cell
        title="是否可以提供发票"
        v-if="form.designerIdentity.includes('SJ')"
      >
        <div class="flex-row-2">
          <van-radio name="0" v-model="form.invoiceFlag">是</van-radio>
          <van-radio name="1" v-model="form.invoiceFlag">否</van-radio>
        </div>
      </van-cell>
      <!-- 是否可以套定金额 -->
      <van-cell
        title="是否可以套定金额"
        class="free"
        v-if="form.designerIdentity.includes('SJ')"
      >
        <div class="flex-row-2" >
          <van-radio name="0" v-model="form.amount">是</van-radio>
          <van-radio name="1" v-model="form.amount">否</van-radio>
        </div>
      </van-cell>
      <!-- 作品上传 -->
      <van-cell
        class="upload list-bor-none"
        title="作品上传:"
      >
        <div class="label">
          doc\docx\xls\xlsx\ppt\pptx\pdf\zip\dwg\rar\格式电子文档，单个文件不超过30M
        </div>
      </van-cell>
      <div class="up-lab">
        <van-uploader
          :before-read="beforeRead"
          upload-icon="../../../assets/images/activities/desiagner/hezuo.png"
          accept="*"
          :after-read="uploadfn"
          v-model="form.file"
          :max-size="30*1024*1024"
          :max-count="3"
          style="padding-left: 15px"
        >
          <div class="upload-div">
            <img
              src="../../../assets/images/activities/desiagner/icon_shu.png"
              alt=""
            />
            <div>作品上传</div>
            <div>(最多三个)</div>
          </div>
        </van-uploader>
      </div>
      <van-field
        v-model="form.username"
        readonly
        label="职业经历"
        placeholder="请填写你的职业经历"
      />
      <van-field
        class="textarea"
        v-model="form.designerCareer"
        rows="3"
        type="textarea"
        maxlength="500"
        placeholder=""
        show-word-limit
      />
      <van-field
        v-model="form.recommendInfo"
        label="推荐人"
        clearable
        placeholder="请输入推荐人用户名或手机号"
        maxlength="20"
      />
    </van-form>
       <van-popup
      v-model="isIdentity"
      round
      :style="{ height: '40%' }"
      position="bottom"
    >
      <div class="show-bar">
        <div @click="isIdentity = false">取消</div>
        <div @click="getIdentity">确认</div>
      </div>
      <div class="scroll">
        <van-checkbox-group v-model="IdentityResult">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in identity"
              clickable
              :key="item.id"
              :title="`${item.text}`"
              @click="toggle4(index)"
            >
              <template #right-icon>
                <van-checkbox :name="item" ref="checkboxes4" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
    </van-popup>

    <!-- 获得城市 -->
    <van-popup v-model="showPC" round position="bottom">
      <van-picker
        @change="onCityChange"
        show-toolbar
        :columns="column"
        @cancel="showPC = false"
        @confirm="onPcConfirm"
      />
    </van-popup>
    <!-- 展示从业时间 -->
    <van-popup v-model="isShowTime" round position="bottom">
      <van-picker
        title="选择你的从业时间"
        show-toolbar
        :columns="yearColumns"
        :default-index="yearSelect"
        @cancel="isShowTime = false"
        @confirm="onGetTime"
      />
    </van-popup>
    <!-- 收费标准 -->
    <van-popup v-model="isFeeScale" round position="bottom">
      <van-picker
        show-toolbar
        :columns="feeScale"
        @cancel="isFeeScale = false"
        @confirm="onFreeScale"
      />
    </van-popup>
    <!-- 多选证书 -->
    <van-popup
      v-model="isShowCe"
      round
      :style="{ height: '40%' }"
      position="bottom"
    >
      <div class="show-bar">
        <div @click="isShowCe = false">取消</div>
        <div @click="onCeConfirm">确认</div>
      </div>
      <div class="scroll">
        <van-checkbox-group v-model="ceResult">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in certificate"
              clickable
              :key="item"
              :title="`${item}`"
              @click="toggle3(index)"
            >
              <template #right-icon>
                <van-checkbox :name="item" ref="checkboxes3" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
    </van-popup>

    <!-- 展示多选系统 -->
    <van-popup
      v-model="issys"
      round
      :style="{ height: '40%' }"
      position="bottom"
    >
      <div class="show-bar">
        <div @click="issys = false">取消</div>
        <div @click="onSysConfirm">确认</div>
      </div>
      <div class="scroll">
        <van-checkbox-group v-model="sysResult">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in sys"
              clickable
              :key="item.id"
              :title="`${item.text}`"
              @click="toggle2(index)"
            >
              <template #right-icon>
                <van-checkbox :name="item" ref="checkboxes2" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
    </van-popup>
    <!-- 展示业态 -->
    <van-popup
      v-model="isFormat"
      round
      :style="{ height: '40%' }"
      position="bottom"
    >
      <div class="show-bar">
        <div @click="isFormat = false">取消</div>
        <div @click="onForMatConfirm">确定</div>
      </div>
      <div class="scroll">
        <van-checkbox-group v-model="forMatResult">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in format"
              clickable
              :key="item.id"
              :title="`${item.text}`"
              @click="toggle1(index)"
            >
              <template #right-icon>
                <van-checkbox :name="item" ref="checkboxes1" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
    </van-popup>
    <!-- 底部的按钮  -->
    <div class="flex-row">
      <div @click="cancel">取消</div>
      <div @click="printFormValue">确定</div>
    </div>
  </div>
</template>

<script>
import headers from '@/components/headers'
import { replaceURL } from '@/api/brand/utils'
import { applyDesigner, getCommData } from '@/api/brand/brands'
import { queryProvince } from '@/api/demands/demand'
import { toLogin, isMobile } from '@/utils/common'
import { getCookie } from '@/utils/cookies'
import axios from 'axios'
import moment from 'moment'
import wxAuth from '@/components/wxAuth'

export default {
  data () {
    return {
      share: {
        title: '解决方案馆',
        desc: '智能化产品方案,产品方案,系统方案,弱电设备方案,厂商方案,产品供应商设计方案,弱电设计方案,热门方案,规划设计方案,顶层设计方案,系统解决方案,集成商方案,招标方案,投标方案,深化设计方案,施工方案',
        imgUrl: 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
        url: window.location.href.split('#')[0]
      },
      // 限制格式
      geshi: [
        'doc',
        'docx',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
        'pdf',
        'zip',
        'dwg',
        'rar'
      ],
      // 系统的数组
      sysResult: [],
      // 业态的数组
      forMatResult: [],
      //  证书的数组
      ceResult: [],
      // Identity
      IdentityResult: [],
      // 证书的输入框
      inputCertificate: '',
      isShowTime: false,
      minDate: new Date(1970, 0, 1),
      maxDate: new Date(2021, 10, 1),
      currentDate: new Date(),
      hraderP: {
        title: '设计师合伙人申请',
        lefticon: true
      },
      // 身份数组
      identity: [
        {
          id: 'SJ',
          text: '设计接单'
        },
        {
          id: 'SG',
          text: '项目合作'
        },
        {
          id: 'CG',
          text: '推荐品牌'
        }
      ],
      // 展示 身份
      isIdentity: false,
      // 收费标准 0:按平方 1:按工时 2:按子系统
      feeScale: [
        {
          id: 0,
          text: '按平方'
        },
        {
          id: 1,
          text: '按工时'
        },
        {
          id: 2,
          text: '按子系统'
        }
      ],
      isShowCe: false,
      certificate: [
        '一级建造师',
        '二级建造师',
        '一级造价工程师',
        '二级造价工程师',
        'PMP证书',
        'CPMP(认证中国项目管理师)',
        '其他'
      ],
      // 展示收费标准
      isFeeScale: false,
      // 展示系统
      sys: [],

      issys: false,
      //
      format: [],
      // 展示业态
      isFormat: false,
      // 省市
      column: [],
      // 展示省市
      showPC: false,
      // 城市
      procity: '',
      designerIdentityText: '',
      isFormat: false,
      form: {
        file: [],
        amount: '0',
        invoiceFlag: '1',
        designerIdentity: []
      },
      userInfo: {},
      yearColumns: [],
      yearSelect: null,
      fileKey: 1,
      recommendId: this.$route.query.recommendId
    }
  },
  mounted () {
    this.yearData()
    this.getData(5)
    this.getData(6)
    this.queryProvince(0)
    this.getUserInfo().then((res) => {
      this.userInfo = res
    })
    if (!isMobile()) {
      console.log(`${process.env.PC_SOLUTION_URL || '//solution.homedo.com'}/design/partner.html`)
      window.location.href = `${process.env.PC_SOLUTION_URL || '//solution.homedo.com'}/design/partner.html`
    }
    if (+this.recommendId) {
      this.getMemberInfoById()
    }
  },
  methods: {
    async getMemberInfoById () {
      let data = new FormData()
      data.append('accountId',this.recommendId)
      const result = await axios({
        method: 'post',
        url:  $HMD$.rApi['B2B'] + "/mall-pcweb-compositeservice/citypartner/financeService/getMemberInfoById",
        data: {
          accountId: this.recommendId
        }
      })
      if (result && result.data && result.data.data) {
        this.form.recommendInfo = result.data.data.userName || ''
      }
    },
    yearData () {
      let newTime = new Date()
      const year = newTime.getFullYear()
      for (let i = 1970; i <= year; i++) {
        this.yearColumns.push(i)
      }
      this.yearSelect = this.yearColumns.indexOf(Number(year))
    },
    // 校验格式
    // 返回布尔值
    beforeRead (file) {
      let index = file.name.lastIndexOf('.')
      let fileName = file.name.substring(index + 1, file.name.length)
      let status = this.geshi.findIndex((item) => item === fileName)
      let size = file.size
      if (status < 0) {
        this.$toast('请上传符合格式的文件')
        return false
      }
      if (size > 30 * 1024 * 1024) {
        this.$toast('请上传30M以下的文件')
        return false
      }
      return true
    },
    // 校验手机号
    validator (val) {
      return /1\d{10}/.test(val)
    },
    async getUserInfo () {
      return new Promise((resolve, reject) => {
        $HMD$.GetLogin(function (data) {
          resolve(data)
        })
      })
    },
    // 多系统确认
    onSysConfirm () {
      this.issys = false
      if (this.sysResult.length >= 1) {
        let data = this.sysResult.map((item) => {
          return item.text
        })
        this.form.designerSystem = data.join('   ')
      } else {
        this.form.designerSystem = ''
      }
    },
    // 多业态确认()
    onForMatConfirm () {
      this.isFormat = false
      if (this.forMatResult.length >= 1) {
        let data = this.forMatResult.map((item) => {
          return item.text
        })
        this.form.designerFormats = data.join('   ')
      } else {
        this.form.designerFormats = ''
      }
    },
    // 复选框
    toggle1 (index) {
      this.$refs.checkboxes1[index].toggle()
    },
    toggle2 (index) {
      this.$refs.checkboxes2[index].toggle()
    },
    toggle3 (index) {
      this.$refs.checkboxes3[index].toggle()
    },
    toggle4 (index) {
      this.$refs.checkboxes4[index].toggle()
    },
    // 获得收费标准
    onFreeScale (value) {
      this.form.sfText = value.text
      this.form.feeScale = value.id
      this.isFeeScale = false
    },
    // 获得从业时间
    onGetTime (value) {
      this.form.designerWorkingTime = value
      this.isShowTime = false
    },
    // 获得城市
    async queryProvince (number) {
      queryProvince(number).then((res) => {
        let { status, data } = res
        if (status == 200) {
          let { code } = data
          if (code == 200) {
            const provinceData = {
              defaultIndex: 0,
              values: data.data.areas.map((item, index) => {
                return {
                  text: item.name,
                  value: item.id,
                  index: index
                }
              })
            }
            this.$set(this.column, 0, provinceData)
            this.getcity(1)
          }
        } else {
          this.$message.error()
        }
      })
    },
    // 获取城市
    getcity (number) {
      queryProvince(number).then((res) => {
        let { status, data } = res
        if (status == 200) {
          let { code } = data
          if (code == 200) {
            const cityData = {
              defaultIndex: 0,
              values: data.data.areas.map((item, index) => {
                return {
                  text: item.name,
                  value: item.id,
                  index: index
                }
              })
            }
            this.$set(this.column, 1, cityData)
          }
        }
      })
    },
    onCityChange (a, b, value) {
      if (value > 0) {
        return
      }
      this.getcity(b[value].value)
    },
    // 获取
    onPcConfirm (value) {
      this.form.designerCityId = value[1].value
      this.form.designerCity = value[1].text
      this.form.designerProvinceId = value[0].value
      this.form.designerProvince = value[0].text
      this.procity = this.form.designerProvince + '-' + this.form.designerCity
      this.showPC = false
    },
    // 证书
    onCeConfirm () {
      // 关闭
      this.isShowCe = false
      if (this.ceResult.length >= 1) {
        this.form.certificate = this.ceResult.join('   ')
      } else {
        this.form.certificate = ''
      }
    },
    // 上传的方法
    uploadfn (file) {
      file.status = 'uploading'
      file.message = '上传中...'
      file.id = this.fileKey
      this.fileKey++
      fetch(
        '/platformApi/OSS/sign/project-homedo/shanghai'
      ).then((response) => {
        return response.json().then((data) => {
          const key = data.dir + data.key + '_${filename}'
          const ossData = new FormData()
          ossData.append('Filename', '${filename}')
          ossData.append('key', key)
          ossData.append('policy', data.policy)
          ossData.append('OSSAccessKeyId', data.OSSAccessKeyId)
          ossData.append('success_action_status', 200)
          ossData.append('signature', data.signature)
          ossData.append('file', file.file, replaceURL(file.file.name))
          axios
            .post(data.host, ossData, { timeout: 300000 })
            .then((res) => {
              const obj = {
                fileName: replaceURL(file.file.name),
                fileUrl: `${data.host}/${key.replace(
                  '${filename}',
                  replaceURL(file.file.name)
                )}`
              }
              console.log(obj)
              file.status = 'done'
              file.message = '上传成功'
              for (let i = 0; i < this.form.file.length; i++) {
                if (this.form.file[i].id === file.id) {
                  if (res.status == 200) {
                    this.form.file[i] = {
                      ...this.form.file[i],
                      ...obj
                    }
                  } else {
                    this.form.file.splice(i, 1)
                  }
                  break
                }
              }
            })
        })
      })
    },
    // 出发  vant 的表单验证
    printFormValue () {
      this.$refs.formData.submit()
    },
    // 提交
    subMit () {
      if (!this.userInfo.AccountId) {
        toLogin()
      }
      let subData = JSON.parse(JSON.stringify(this.form))
      subData.userId = getCookie('accountId') || getCookie('AccountId')
      subData.source = 1
      subData.designerSystem = this.filterArrar(this.sysResult)
      subData.designerFormats = this.filterArrar(this.forMatResult)
      subData.file = subData.file.map((item) => {
        return {
          fileName: item.fileName,
          fileUrl: item.fileUrl
        }
      })
      subData.operationId = this.userInfo.AccountId
      subData.operationName = this.userInfo.AccountName
      if (this.ceResult.includes('其他')) {
        subData.certificate = this.inputCertificate ? this.ceResult.join(',') + ',' + this.inputCertificate : this.ceResult.join(',')
      } else {
        subData.certificate = this.ceResult.join(',')
      }
      subData.designerIdentity = subData.designerIdentity.join(',')
      applyDesigner(subData).then((res) => {
        let { status, data } = res
        if (status == 200) {
          let { respCode, respDesc } = data
          if (respCode === '0000') {
            this.$toast.success('提交成功')
            setTimeout(() => {
              this.$router.push('/activity/dsg/designer.html')
            }, 300)
          } else {
            console.log('提交')
            this.$toast.fail(respDesc)
          }
        }
      })
    },
    // cancel
    cancel () {
      this.$router.push('/activity/dsg/designer.html')
    },
    filterArrar (array) {
      let subSys = array.map((item) => {
        return item.id
      })
      let data = subSys.join(',')
      return data
    },
    // 获取下拉列表的数据
    getData (num) {
      getCommData(num).then((res) => {
        let { status, data } = res
        if (status == 200) {
          let { respCode, respDesc } = data
          if (respCode === '0000') {
            if (num == 5) {
              this.sys = data.data.records.map((items) => {
                return {
                  id: items.id,
                  text: items.name
                }
              })
            } else {
              this.format = data.data.records.map((items) => {
                return {
                  id: items.id,
                  text: items.name
                }
              })
            }
          }
        }
      })
    },
    // 获取 身份
    getIdentity () {
      this.designerIdentityText = this.IdentityResult.map(item => {
        return item.text
      }).join('   ')
      this.form.designerIdentity = this.IdentityResult.map(item => {
        return item.id
      })
      this.isIdentity = false
    }
  },
  components: {
    headers,
    wxAuth
  }
}
</script>

<style scoped>
.wrap {
  background: #fff;
}
.form {
  padding: 0 10px;
}
.textarea {
  width: 319px;
  height: 118px;
  background: #f8f9fb;
  margin: 12px auto;
  margin-top: -2px;
}

>>> .van-cell:nth-last-child(2)::after {
  border-bottom: none !important;
}
.flex-row-2 {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 0.8rem;
}
.flex-row-2 div:nth-child(2) {
  margin-left: 30px;
}
>>> .van-cell:nth-child(15):after {
  border-bottom: none !important;
}
>>> .van-checkbox__label {
  color: rgba(153, 153, 153, 1) !important;
  font-size: 10px;
  margin-left: 2px !important ;
}
>>> .van-checkbox__icon .van-icon {
  font-size: 12px;
}
>>> .van-checkbox__icon--checked .van-icon {
  color: #fff;
  background-color: #1989fa;
  border-color: #1989fa;
  font-size: 12px;
}
.free::before {
  position: absolute;
  left: 7px;
  color: #ee0a24;
  font-size: 0.373333rem;
  content: "*";
}
.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  background: #fff;
  height: 100px;
}
.flex-row div {
  width: 142px;
  height: 44px;
}
.flex-row div:nth-child(1) {
  background: rgba(202, 202, 202, 1);
  color: #fff;
  font-size: 16px;
  line-height: 44px;
  text-align: center;
  border-radius: 22px;
}
.flex-row div:nth-child(2) {
  background: rgba(46, 123, 255, 1);
  color: #fff;
  font-size: 16px;
  line-height: 44px;
  text-align: center;
  border-radius: 22px;
}
.upload >>> .van-cell__value {
  min-width: 80%;
}
.upload .label {
  width: 100%;
  font-size: 13px;
  text-align: justify;
}
.upload-div {
  width: 80px;
  height: 80px;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 1px;
  margin-left: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.upload-div img {
  width: 20px;
  height: 20px;
}
.upload-div div {
  font-size: 12px;
  color: rgba(151, 151, 151, 1);
}
>>> .van-icon-description::before {
  background: url("../../../assets/images/activities/desiagner/wendang.png")
    100% 100% no-repeat;
  background-size: 100%;
  width: 20px;
  height: 35px;
  content: "";
}
>>> .van-radio__label {
  font-size: 10px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 18px;
}
.show-bar {
  width: 100%;
  max-width: 343px;
  height: 44px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 16px;
  z-index: 999;
  position: sticky;
  top: 0;
  left: 0;
  background: #fff;
}
.show-bar div:nth-child(1) {
  color: #969799;
  font-size: 0.373333rem;
  line-height: 44px;
}
.show-bar div:nth-child(2) {
  color: #576b95;
  font-size: 0.373333rem;
  line-height: 44px;
}
.scroll {
  height: cale(100% - 44px);
  overflow-y: scroll;
  overflow: hidden;
}
>>> .van-field__control {
  display: block;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  color: #323233;
  line-height: inherit;
  text-align: left;
  background-color: transparent;
  border: 0;
  white-space: nowrap;
  overflow: hidden;
  resize: none;
  text-overflow: ellipsis;
}
.list-two {
  flex-wrap: wrap;
  overflow: inherit;
}
.list-two.nopdb {
  padding-bottom: 0;
}
.van-cell {
  line-height: 30px;
  min-height: 50px;
}
>>> .list-two-one.van-cell::after {
  width: 251px;
  left: auto;
}

>>> .list-bor-none.van-cell::after {
  display: none;
}
>>> .list-two .van-field__label {
    transform: translateY(-22px);
}
>>> .list-two.van-cell--required::before {
    top: -11px;
}
>>> .list-two-hide-val .van-field__value {
  display: none;
}
.list-two-pla {
  flex: 1;
  color: #999999;
}
.list-two-more-box {
  flex: 1;
  display: flex;
}
.list-two-val-box {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  padding-top: 5px;
}
.list-two-val-item {
  height: 20px;
  background: #f0f0f0;
  padding: 0 5px;
  line-height: 20px;
  color: #333333;
  font-size: 12px;
  margin-right: 6px;
  margin-bottom: 15px;
}
input::-webkit-input-placeholder {
  color: #999999!important;
}
.van-field--error .list-two-pla{
  color: #ee0a24;
}
.up-lab {
  width: 343px;
  height: 99px;
  opacity: 1;
  background: #fafafa;
  border-radius: 2px;
  display: flex;
  align-items: center;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/view/activities/designer/apply.vue